import React from 'react';
import TextInput from '../input/TextInput';
import { AddAccount } from '../../api/mutations';
import { commitMutation } from 'react-relay';
import environment from '../../api/environment';
import Popup from '../Popup';
import { PopupProps } from '../Popup/PopupProvider';

function NewAccountPopup({ onCancel }: PopupProps) {
  const [accountName, setAccountName] = React.useState('');

  const onSave = async () => {
    const variables = {
      name: accountName,
    };
    //@ts-ignore
    commitMutation(environment, {
      mutation: AddAccount,
      variables,
      onCompleted: (response: any, errors: any) => {
        console.log('Response received from server.', response, errors);
      },
      onError: (err: any) => console.error(err),
    });
  };

  return (
    <Popup onSave={onSave} onCancel={onCancel}>
      <TextInput
        label='Account Name'
        fullWidth
        value={accountName}
        onChange={(name) => setAccountName(name)}
        placeholder={'Account name'}
      />
    </Popup>
  );
}

export default NewAccountPopup;
